<h2 class="p-6 pb-0">
  @switch (type) {
    @case (types.Create) {
      Створення візиту
    }
    @case (types.Edit) {
      Редагування візиту
    }
    @case (types.Delete) {
      Видалення візиту
    }
  }
</h2>
<mat-dialog-content>
  @if (!loading()) {
    @switch (type) {
      @case (types.Delete) {
        @if (!errorMessage()) {
          <div class="flex gap-6 rounded-xl bg-warning-50 p-8">
            <div>
              <img
                priority="true"
                alt="Warning Icon"
                width="40"
                height="40"
                [ngSrc]="'/assets/icons/ic_warning_fire.svg'"
              />
            </div>
            <div class="flex flex-col gap-4">
              <span class="flex flex-col gap-1">
                <span>Ви збираєтесь видалити візит:</span>
                <span class="text-lg font-semibold">
                  {{ appointment.metadata.name }}
                </span>
              </span>

              <span>Ви дійсно бажаєте його видалити?</span>
            </div>
          </div>
        }
      }
      @default {
        <form
          id="appointmentForm"
          class="flex flex-col"
          [formGroup]="modalForm"
          (ngSubmit)="submit()"
        >
          <mat-form-field class="w-full">
            <mat-label>Тип послуги</mat-label>
            <input
              matInput
              readonly
              type="text"
              [value]="'medicalServices.prescriptionTypes.' + fc.appointmentType.value | translate"
            />
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>Назва послуги</mat-label>
            <input
              matInput
              readonly
              type="text"
              [value]="fc.name.value || 'Не вказано назву послуги'"
            />
          </mat-form-field>

          <div class="mb-4">
            <div class="flex justify-between">
              <h3
                id="radio-group-label"
                class="text-neutral-500"
              >
                Вкажіть тип візиту
              </h3>
              @if (!!fc.franchise.value) {
                <div class="mb-4 flex items-center gap-2">
                  <shared-info-badge
                    class="text-nowrap"
                    [color]="colors.Blue"
                    [withBorder]="true"
                    [fontSize]="'text-xs'"
                    [text]="'prescription.labels.franchise' | translate: { percentage: fc.franchise.value }"
                  ></shared-info-badge>
                  <mat-icon
                    class="text-info-600"
                    [fontIcon]="'info_outline'"
                    [matTooltip]="getFranchiseLabel(fc.franchise.value)"
                  ></mat-icon>
                </div>
              }
            </div>
            <mat-radio-group
              aria-labelledby="radio-group-label"
              class="flex gap-4"
              [ngClass]="{ 'pointer-events-none opacity-50': !!appointment }"
              [formControl]="fc.appointmentModalFlow"
            >
              <mat-radio-button [value]="'binding'"> Прив'язати до візиту </mat-radio-button>
              <mat-radio-button [value]="'manual'"> Створити візит вручну </mat-radio-button>
            </mat-radio-group>
          </div>
          @if (fc.appointmentModalFlow.value === "binding") {
            <hm-eleks-appointment-binding-form
              [formControl]="fc.eleksBinding"
              [type]="type"
              [action]="action"
              [appointment]="appointment"
            ></hm-eleks-appointment-binding-form>
          }
          @if (fc.appointmentModalFlow.value === "manual") {
            <hm-manual-appointment-form
              [formControl]="fc.manualAppointment"
              [type]="type"
              [action]="action"
              [appointment]="appointment"
            ></hm-manual-appointment-form>
          }
        </form>
      }
    }
    @if (errorMessage()) {
      <shared-warning-message
        [type]="warningTypes.Error"
        [text]="errorMessage()"
      ></shared-warning-message>
    }
  } @else {
    <div class="flex items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="gap-4">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    (click)="closeDialog()"
  >
    Назад
  </button>
  @switch (type) {
    @case (types.Delete) {
      <button
        class="btn btn-primary"
        [type]="'submit'"
        [disabled]="errorMessage() === eleksError"
        (click)="submit()"
      >
        Скасувати
      </button>
    }
    @default {
      <button
        class="btn btn-primary"
        form="appointmentForm"
        [type]="'submit'"
        [disabled]="!isFormValid()"
      >
        @if (fc.appointmentModalFlow.value === "binding") {
          Підтвердити прив'язку
        } @else {
          Підтвердити
        }
      </button>
    }
  }
</mat-dialog-actions>
